export { default } from "./ManageNotesSlideout";
